import * as React from 'react';
import * as Yup from 'yup';
import {RouteComponentProps, withRouter} from 'react-router-dom';
import {inject, observer} from 'mobx-react';
import {Formik, FormikProps} from 'formik';
import FormBase, {FormValues} from './private/AirbnbCodeVerificationFormBase';
import {AirbnbAuth, AirbnbCodeVerification} from '../../../../models/airbnbAuthModel';

export interface AirbnbCodeVerificationFormProps {
  method: AirbnbCodeVerification;
}

interface WithInjectedProps extends AirbnbCodeVerificationFormProps, RouteComponentProps {
  airbnbAuth: AirbnbAuth;
}

@inject('airbnbAuth')
@observer
class AirbnbCodeVerificationForm extends React.Component<AirbnbCodeVerificationFormProps & RouteComponentProps, {}> {
  public render() {
    const {verificationPassed, verificationFailed, verifying} = this._withInjectedProps.airbnbAuth;

    return (
      <Formik
        initialValues={{code: ''}}
        validationSchema={this._validationSchema}
        onSubmit={this._handleSubmit}
        render={(props: FormikProps<FormValues>) => (
          <FormBase
            passed={verificationPassed}
            failed={verificationFailed}
            loading={verifying}
            // handleCodeResend={this._handleCodeResend}
            // requestingNewCode={requestingNewCode}
            {...props}
          />
        )}
      />
    );
  }

  private get _validationSchema() {
    return Yup.object().shape({
      code: Yup.string().required('Please enter the code you have received.')
    });
  }

  private _handleSubmit = ({code}: FormValues) => {
    this._withInjectedProps.airbnbAuth.verify(this.props.method, code, {onSuccess: this._handleVerificationSuccess});
  };

  private _handleVerificationSuccess = () => this._withInjectedProps.history.push('/connect/airbnb/choose_listings');

  // private _handleCodeResend = () => {
  //   this._withInjectedProps.auth.resendVerificationCode();
  // };

  private get _withInjectedProps() {
    return this.props as WithInjectedProps;
  }
}

export default withRouter(AirbnbCodeVerificationForm);



// WEBPACK FOOTER //
// ./src/containers/AirbnbCodeVerificationProcedure/private/AirbnbCodeVerificationForm/AirbnbCodeVerificationForm.tsx